<template>
    <div id="BaseTextArea">
        <textarea name="" id="" cols="52%" rows="10" :placeholder="inputPlaceholder"></textarea>
    </div>
</template>

<script>
export default {
    name: 'BaseTextArea',
    props:{
        inputPlaceholder:{
            type: String,
            required: false,
            default: 'Digite aqui'
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/blocks/BaseTextArea.vue